export function partiallyMaskEmail(email: string) {
  const [localPart, domainPart] = email.split("@");
  const maskedLocalPart =
    localPart.slice(0, 4) + localPart.slice(2).replace(/./g, "*");
  return maskedLocalPart + "@" + domainPart;
}
